/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import Select from 'components/Select';
import {
  Badge,
  Button,
  Calendar,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  TimePicker,
  Typography,
} from 'antd';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getCandidato, getCandidatos, getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import { getDirectorioDeAreas } from 'api/catalogos/CatalogoDeAreas';
import { getCategoriasDePuestos } from 'api/catalogos/categoriaDePuestos';
import { getEstadosGlobales } from 'api/catalogos/index';
import { getPlazas } from 'api/catalogos/plazas';
import { getPuestos } from 'api/catalogos/puestos';
import { getSindicatos } from 'api/catalogos/sindicatos';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getCitas, patchCita, postCita } from 'api/reclutamiento/citas';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  getComprobantesDeEstudio,
  getSolicitudDeContratacion,
  getSolicitudDeContratacionvistaOptimized,
  getSolicitudesDeContratacion,
} from 'api/reclutamiento/SolicitudesDeContratacion';
import { checkToken } from 'api/utils';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { onError } from 'utils/handlers';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import ModalConfirmation from 'components/ModalConfirmation';
import { getCitasEstado } from 'api/reclutamiento/estadosCitas';
import HistoricoCitas from './CitasHistorico';

const { Title } = Typography;
// Construye los paths concatenados
const buildAreaPaths = (areasData) => {
  const areaMap = new Map(areasData.map((a) => [a.id, a]));

  return areasData.map((area) => {
    const path = [];
    let current = area;

    while (current) {
      path.unshift(current.nombre.trim());
      current = areaMap.get(current.directorio_area_padre);
    }

    return {
      ...area,
      path: path.join(' / '),
    };
  });
};

const normalizeTree = (dataTree) => {
  const sortedData = buildAreaPaths(dataTree).sort((a, b) => a.clave.localeCompare(b.clave));
  const map = new Map();
  const tree = [];

  sortedData.forEach((item) => {
    const node = {
      title: `${item.clave} - ${item.nombre.trim()}`,
      value: item.id,
      key: item.id,
      children: [],
      path: item.path,
    };
    map.set(item.id, node);
  });

  sortedData.forEach((item) => {
    const parentId = item.directorio_area_padre;
    if (parentId && map.has(parentId)) {
      const parent = map.get(parentId);
      parent.children.push(map.get(item.id));
      parent.disabled = true;
    } else {
      tree.push(map.get(item.id));
    }
  });

  return tree;
};

export default function CitasCalendario({ candidato }) {
  const [form] = Form.useForm();

  const [date, setDate] = useState(moment());
  const [search, setSearch] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [editingCita, setEditingCita] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [selectedCita, setSelectedCita] = useState(null);
  const [cancelForm] = Form.useForm();
  const [attendForm] = Form.useForm();
  const [visibleAtendido, setVisibleAtendido] = useState(false);
  const [solicitudes, setSolicitudes] = useState();
  const [estados, setEstados] = useState([]);
  const [estadosCitas, setEstadosCitas] = useState([]);
  const [directorioDeAreas, setDirectorioDeAreas] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [data, setData] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);

  const [empleadoId, setEmpleadoId] = useState();
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [sindicatos, setSindicatos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [tipoNominaEmpleadoID, setTipoNominaEmpleadoID] = useState([]);
  const [estadosDelEmpleado, setEstadosDelEmpleado] = useState([]);
  const [periodosDetallesFiltered, setPeriodosDetallesFiltered] = useState([]);
  const [nominas, setNominas] = useState([]);
  const [nominaPlaza, setNominaPlaza] = useState();
  const [comprobantesDeEstudio, setComprobantesDeEstudio] = useState([]);
  const [nivelEstudio, setNivelEstudio] = useState([]);
  const [candidatos, setCandidatos] = useState([]);

  const [open, setVisible] = useState(false);
  const [openModalEmpleado, setOpenModalEmpleados] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('solicitante');
  const [IsDisabledCompetenciasTab, setIsDisabledCompetenciasTab] = useState(true);
  const [IsDisabledFuncionesTab, setIsDisabledFuncionesTab] = useState(true);
  const [IsDisabledSolicitanteTab, setIsDisabledSolicitanteTab] = useState(false);
  const [IsDisabledPlazaTab, setIsDisabledPlazaTab] = useState(false);

  const [competencias, setCompetencias] = useState([]);
  const [openModalComp, setOpenModalComp] = useState(false);
  const [selectedCompIndex, setSelectedCompIndex] = useState(null);
  const [formCompetencia] = Form.useForm();
  const [selectedRowKeysComp, setSelectedRowKeysComp] = useState([]);

  const [citas, setCitas] = useState([]);
  // Adaptador para transformar el formato de citas recibido
  async function adaptarCitas(rawCitas, candidatosVista) {
    if (!rawCitas || !Array.isArray(rawCitas)) return [];

    return rawCitas.map((cita) => {
      const candidatoData = candidatosVista.find((c) => c.id === cita.candidato);

      return {
        id: cita.id,
        folio: cita.folio,
        fecha: cita.fecha,
        horario: cita.horario,
        estado_de_cita: cita.estado_de_cita,
        atendida: cita.atendida,
        comentarios: cita.comentarios,

        // Info básica del candidato
        candidatoId: candidatoData?.id,
        candidatoNombre: candidatoData?.candidato_numero_y_nombre_completo,

        // Info de solicitante
        solicitanteNombre: candidatoData?.solicitante,
        solicitantePlaza: candidatoData?.solicitante_plaza_clave_y_descripcion,
        solicitantePuesto: candidatoData?.solicitante_puesto_clave_y_descripcion,
        solicitanteArea: candidatoData?.solicitante_directorio_de_area_clave_y_nombre,

        // Info de vacante
        vacantePlaza: candidatoData?.vacante_plaza_clave_y_descripcion,
        vacantePuesto: candidatoData?.vacante_puesto_clave_y_descripcion,
        vacanteArea: candidatoData?.vacante_directorio_de_area_clave_y_nombre,
      };
    });
  }

  const fetchData = async () => {
    setLoading(true);
    try {
      const [_citas, _candidatosVista] = await Promise.all([
        getCitas(),
        getCandidatovistaOptimized(),
      ]);

      if (Array.isArray(_citas)) {
        const citasAdaptadas = await adaptarCitas(_citas, _candidatosVista);
        setCitas(citasAdaptadas);
      } else {
        setCitas([]);
      }
    } catch (err) {
      setCitas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        // Primero obtenemos las solicitudes
        const [
          _solicitudes,
          _citas,
          _estados,
          _estadosCitas,
          _candidatosVista,
        ] = await Promise.all([
          getSolicitudDeContratacionvistaOptimized(),
          getCitas(),
          getEstadosGlobales(),
          getCitasEstado(),

          getCandidatovistaOptimized(),
        ]);

        if (mounted) {
          // Asignamos las solicitudes primero
          setSolicitudes(_solicitudes.results || []);

          // Luego adaptamos las citas con las solicitudes ya cargadas
          const citasAdaptadas = await adaptarCitas(_citas, _candidatosVista);
          setCitas(citasAdaptadas);

          // Asignamos el resto de los datos
          setEstados(_estados);
          setEstadosCitas(_estadosCitas);
        }
      } catch (error) {
        onError(error, 'Error fetching data');
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = { ...form.getFieldsValue() };

      //  Normalizar fecha y horario
      if (moment.isMoment(values.fecha)) {
        values.fecha = values.fecha.format('YYYY-MM-DD');

        // Normalizar hora
        if (moment.isMoment(values.horario)) {
          values.horario = values.horario.format('HH:mm:ss');
        }

        // Concatenar fecha + hora → fecha_y_hora
        if (values.fecha && values.horario) {
          values.fecha_y_hora = `${values.fecha}T${values.horario}`;
        }
      }
      // if (!values.estado_de_cita) {
      //   values.estado_de_cita = 1; //  fallback por si acaso
      // }

      // Si viene el candidato desde el padre, lo asignamos
      if (!editingCita && candidato) {
        values.candidato = candidato.id;
        values.solicitud_de_contratacion = candidato.vacante_id;
      }

      let saved;
      if (editingCita) {
        saved = await patchCita(editingCita.id, values);
      } else {
        saved = await postCita(values);
      }

      if (saved) {
        if (_continue) {
          await fetchData();
          setEditingCita(saved);
          form.setFieldsValue(saved);
        } else {
          setModalVisible(false);
          setEditingCita(null);
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const selectedDate = date.format('YYYY-MM-DD');
  const citasCoincidenBusqueda = (citas || []).filter((cita) => {
    const valores = `${cita.fecha} ${cita.vacantePlaza} ${cita.vacantePuesto} ${cita.solicitanteNombre} ${cita.candidatoNombre} ${cita.vacanteAreaNombre} ${cita.vacanteAreaCodigo} ${cita.vacanteCodigo} ${cita.vacantePuestoCodigo}`;
    return valores.toLowerCase().includes(search.toLowerCase());
  });

  const mostrarCitas = search.length > 0
    ? citasCoincidenBusqueda
    : (citas || []).filter((c) => c.fecha === selectedDate);

  const dateCellRender = (value) => {
    const currentDate = value.format('YYYY-MM-DD');
    const citasCount = (citas || []).filter((c) => c.fecha === currentDate).length;
    return citasCount > 0 ? (
      <div style={{ textAlign: 'center' }}>
        <Badge count={citasCount} style={{ backgroundColor: '#1890ff' }} />
      </div>
    ) : null;
  };
  const abrirModalNuevaCita = () => {
    setEditingCita(null);
    form.resetFields();

    const initialValues = {
      fecha: moment(),
      estado_de_cita: 1,
      candidato: candidato?.id,
      candidatoNombre: candidato
        ? `${candidato.candidato_numero_y_nombre_completo}`
        : undefined,
      vacantePlaza: candidato?.vacante_plaza_clave_y_descripcion,
      vacanteCodigo: candidato?.vacante_plaza_id,
      vacantePuesto: candidato?.vacante_puesto_clave_y_descripcion,
      vacantePuestoCodigo: candidato?.vacante_puesto_id,
      solicitanteNombre: candidato?.solicitante,
      vacanteAreaNombre: candidato?.vacante_directorio_de_area_clave_y_nombre,
      vacanteAreaCodigo: candidato?.vacante_directorio_de_area_id,
    };

    form.setFieldsValue(initialValues);
    setModalVisible(true);
  };

  const abrirModalReagendar = (cita) => {
    setEditingCita(cita);

    form.setFieldsValue({
      ...cita,
      fecha: cita.fecha ? moment(cita.fecha, 'YYYY-MM-DD') : null,
      horario: cita.horario ? moment(cita.horario, 'HH:mm:ss') : null,
      estado_de_cita: 2, // <-- Forzar estado en REAGENDADA
      vacanteAreaNombre: cita.vacanteArea,
      candidato: cita.candidatoId,
    });

    setModalVisible(true);
  };

  const guardarCita = (values) => {
    const nuevaCita = {
      ...values,
      id: editingCita ? editingCita.id : Date.now(),
      fecha: values.fecha.format('YYYY-MM-DD'),
    };

    if (editingCita) {
      setCitas((prev) => prev.map((c) => (c.id === editingCita.id ? nuevaCita : c)));
    } else {
      setCitas((prev) => [...prev, nuevaCita]);
    }

    setModalVisible(false);
    setEditingCita(null);
    form.resetFields();
  };

  const onConfirmCancelar = async (values) => {
    try {
      setLoading(true);

      if (!selectedCita) {
        setLoading(false);
        setVisibleCancelar(false);
        return;
      }

      const res = await patchCita(selectedCita.id, {
        estado_de_cita: 5, // CANCELADA
        comentarios: values.comentarios ?? '',
        fecha_de_cancelacion: null, // <- backend pondrá la fecha actual
        fecha_y_hora_cancelacion: null, // <- backend pondrá la hora actual
      });

      if (res) {
        await fetchData();
        setVisibleCancelar(false);
        setSelectedCita(null);
        form.resetFields(); // limpia comentarios y los campos display
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmAtendida = async (values) => {
    try {
      setLoading(true);

      if (!selectedCita) {
        setLoading(false);
        setVisibleAtendido(false);
        return;
      }

      const res = await patchCita(selectedCita.id, {
        estado_de_cita: 3, // ATENDIDA
        comentarios: values.comentarios ?? '',
      });

      if (res) {
        await fetchData();
        setVisibleAtendido(false);
        setSelectedCita(null);
        attendForm.resetFields(); // limpiar
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  return (
    <div>
      <Spin tip="Cargando..." spinning={loading}>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <Title level={3}>Calendario de Citas</Title>
          </Col>
          <Col>
            <Button
              icon={<PlusOutlined />}
              onClick={abrirModalNuevaCita}
              style={{ fontWeight: 'bold' }}
            >
              Nueva Cita
            </Button>
          </Col>

        </Row>

        <Row gutter={24}>
          <Col xs={24} md={16}>
            <Calendar
              value={date}
              onSelect={(value) => setDate(value)}
              dateCellRender={dateCellRender}
            />
          </Col>

          <Col xs={24} md={8}>
            <Title level={4} style={{ marginBottom: 8 }}>
              {search.length > 0
                ? `Resultados de búsqueda (${mostrarCitas.length})`
                : `Citas del ${date.format('LL')}`}
            </Title>

            <Input
              prefix={<SearchOutlined />}
              placeholder="Buscar en todas las citas..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            <Card bodyStyle={{ padding: 12 }}>
              {mostrarCitas.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {mostrarCitas.map((cita) => (
                    <Card key={cita.id} size="small" bordered>
                      <Title level={5} style={{ margin: 0 }}>
                        Folio:
                        {' '}
                        {cita.folio}
                      </Title>

                      <div>
                        <strong>Fecha:</strong>
                        {' '}
                        {moment(cita.fecha).format('LL')}
                      </div>

                      <div>
                        <strong>Hora:</strong>
                        {' '}
                        {cita.horario ? moment(cita.horario, 'HH:mm:ss').format('HH:mm') : ''}
                      </div>

                      <div>
                        <strong>Candidato:</strong>
                        {' '}
                        {cita.candidatoNombre}
                      </div>

                      <div>
                        <strong>Solicitante:</strong>
                        {' '}
                        {cita.solicitanteNombre}
                      </div>

                      <div>
                        <strong>Vacante:</strong>
                        {' '}
                        {cita.vacantePlaza}
                        {' '}
                        /
                        {' '}
                        {cita.vacantePuesto}
                      </div>

                      <div>
                        <strong>Área:</strong>
                        {' '}
                        {cita.vacanteArea}
                      </div>

                      <div>
                        <strong>Estado:</strong>
                        {' '}
                        {estadosCitas.find((e) => e.id === cita.estado_de_cita)?.descripcion
                        || cita.estado_de_cita}
                      </div>

                      <div style={{
                        display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8,
                      }}
                      >
                        <Button
                          type="default"
                          style={{ fontWeight: 'bold', width: '100%' }}
                          onClick={() => abrirModalReagendar(cita)}
                        >
                          Reagendar
                        </Button>

                        <Button
                          danger
                          style={{ fontWeight: 'bold', width: '100%' }}
                          onClick={() => {
                            if (!cita?.id) {
                              onError('No se pudo identificar la cita a cancelar');
                              return;
                            }

                            setSelectedCita(cita);

                            cancelForm.setFieldsValue({
                              fecha_cancelacion_display: moment().format('YYYY-MM-DD'),
                              hora_cancelacion_display: moment().format('HH:mm'),
                              comentarios: '',
                            });

                            setVisibleCancelar(true);
                          }}
                        >
                          Cancelar Cita
                        </Button>

                        <Button
                          style={{
                            fontWeight: 'bold',
                            width: '100%',
                            backgroundColor: '#d9f7be', // verde claro
                            borderColor: '#237804', // verde oscuro
                            color: '#237804', // texto verde oscuro
                          }}
                          onClick={() => {
                            if (!cita?.id) {
                              onError('No se pudo identificar la cita a marcar como atendida');
                              return;
                            }

                            setSelectedCita(cita);

                            attendForm.setFieldsValue({
                              comentarios: '',
                            });

                            setVisibleAtendido(true);
                          }}
                        >
                          Marcar Atendida
                        </Button>
                      </div>

                    </Card>

                  ))}
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: 32, color: '#999' }}>
                  No hay coincidencias.
                </div>
              )}
            </Card>
          </Col>
        </Row>

        <Modal
          open={modalVisible}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width={600}
          title={(
            <FormSubmitControls
              label={editingCita ? 'Reagendar Cita' : 'Nueva Cita'}
              onFinish={() => form.submit()}
              onCancel={() => setModalVisible(false)}
              loading={loading}
              allowSave
            />
  )}
          onCancel={() => setModalVisible(false)}
        >
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={16}>
              <Col xs={24} sm={12}><Form.Item label="Fecha" name="fecha" rules={[{ required: true }]}><DatePicker style={{ width: '100%' }} /></Form.Item></Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Hora"
                  name="horario"
                  rules={[{ required: true, message: 'La hora es obligatoria' }]}
                >
                  <TimePicker format="HH:mm" style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                {/* Campo oculto que guarda el ID del candidato */}
                <Form.Item name="candidato" hidden>
                  <Input />
                </Form.Item>

                {/* Campo visible solo de lectura con el nombre */}
                <Form.Item label="Candidato" name="candidatoNombre">
                  <Input disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}><Form.Item label="Área" name="vacanteAreaNombre"><Input disabled /></Form.Item></Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  label="Puesto"
                  name="vacantePuesto"
                >
                  <Input disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Plaza" name="vacantePlaza">
                  <Select
                    keyProp="id"
                    labelProp="clave_y_descripcion"
                    dataSource={plazas}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}><Form.Item label="Solicitante" name="solicitanteNombre"><Input disabled /></Form.Item></Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label="Estado de la Cita"
                  name="estado_de_cita"
                 // rules={[{ required: true, message: 'El estado es obligatorio' }]}
                  hasFeedback
                  initialValue={1}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estadosCitas}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label="Observaciones"
                  name="comentarios"

                >
                  <Input.TextArea rows={3} placeholder="Escribe observaciones sobre la cita" />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={12}>
                <Form.Item
                  label="Estado de la Cita"
                  name="estado_de_cita"

                >
                  <Select placeholder="Selecciona un estado">
                    {estadosCitas.map((estado) => (
                      <Select.Option key={estado.id} value={estado.id}>
                        {estado.descripcion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
              <HistoricoCitas citaId={editingCita?.id || selectedCita?.id || null} />

            </Row>
          </Form>
        </Modal>
        <Modal
          open={visibleCancelar}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width={500}
          title={(
            <FormSubmitControls
              label="Cancelar Cita"
              onFinish={() => cancelForm.submit()}
              onCancel={() => setVisibleCancelar(false)}
              loading={loading}
              allowSave
            />
  )}
          onCancel={() => setVisibleCancelar(false)}
        >
          <Form form={cancelForm} layout="vertical" onFinish={onConfirmCancelar}>
            {/* Fecha de cancelación (solo display) */}
            <Form.Item label="Fecha de cancelación" name="fecha_cancelacion_display">
              <Input disabled />
            </Form.Item>

            {/* Hora de cancelación (solo display) */}
            <Form.Item label="Hora de cancelación" name="hora_cancelacion_display">
              <Input disabled />
            </Form.Item>

            {/* Observaciones */}
            <Form.Item
              label="Observaciones"
              name="comentarios"
              rules={[{ required: true, message: 'Por favor escribe el motivo de la cancelación' }]}
            >
              <Input.TextArea rows={3} placeholder="Escribe el motivo de la cancelación" />
            </Form.Item>
            <HistoricoCitas citaId={editingCita?.id || selectedCita?.id || null} />
          </Form>
        </Modal>

        <Modal
          open={visibleAtendido}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width={500}
          title={(
            <FormSubmitControls
              label="Marcar como Atendida"
              onFinish={() => attendForm.submit()}
              onCancel={() => setVisibleAtendido(false)}
              loading={loading}
              allowSave
            />
  )}
          onCancel={() => setVisibleAtendido(false)}
        >
          <Form form={attendForm} layout="vertical" onFinish={onConfirmAtendida}>
            {/* Solo comentarios */}
            <Form.Item
              label="Observaciones"
              name="comentarios"
              rules={[{ required: false }]}
            >
              <Input.TextArea rows={3} placeholder="Escribe observaciones de la atención" />
            </Form.Item>
            <HistoricoCitas citaId={editingCita?.id || selectedCita?.id || null} />
          </Form>
        </Modal>

      </Spin>
    </div>
  );
}
